import { useParams } from 'react-router';

import { clientPath, projectPath } from '@/api/clients.ts';
import { useGetEmployeeClient } from '@/api/generated/clients.ts';
import { useGetEmployeeRecap } from '@/api/generated/recaps.ts';
import { useWorkspacePath } from '@/api/workspaces.ts';
import Breadcrumbs from '@/core/components/Breadcrumbs.tsx';
import useRecapTitle from '@/recaps/useRecapTitle.ts';

// The crumbs a client's employee sees on the pages they share with the members (plan/DECISIONS.md D61), read from the
// employees' endpoints.

export const EmployeeClientCrumb = () => {
    const client = useGetEmployeeClient();
    return <>{client.data?.name}</>;
};

export const EmployeeProjectCrumb = () => {
    const { projectSlug } = useParams();
    const client = useGetEmployeeClient();
    return <>{client.data?.projects.find((project) => project.slug === projectSlug)?.name ?? projectSlug}</>;
};

export const EmployeeRecapCrumb = ({ publicId }: { publicId: string }) => {
    const getRecapTitle = useRecapTitle();
    const recap = useGetEmployeeRecap(publicId);

    if (recap.error) return <>{publicId}</>;
    if (!recap.data) return null;
    return <>{getRecapTitle(recap.data)}</>;
};

// Its client and project before it, linked to their pages.
export const EmployeeRecapProjectCrumbs = ({ publicId }: { publicId: string }) => {
    const recap = useGetEmployeeRecap(publicId);
    const workspacePath = useWorkspacePath();
    const project = recap.data?.project;
    if (!project) return null;

    return (
        <>
            {project.client && (
                <Breadcrumbs.Item href={workspacePath(clientPath(project.client))}>
                    {project.client.name}
                </Breadcrumbs.Item>
            )}
            <Breadcrumbs.Item href={workspacePath(projectPath(project))}>{project.name}</Breadcrumbs.Item>
        </>
    );
};
